module.exports = __webpack_public_path__ + "img/berg.c64c23b3.jpg";